/** A world's invitation: the link its QR code carries, and its code as shown. */
import { worldLink } from '@platform/links';

import { displayCode } from './lobby';

export interface Invite {
  world: string;
  link: string;
  code: string;
}

export const inviteTo = (worldId: string): Invite => ({
  world: worldId,
  link: worldLink(worldId),
  code: displayCode(worldId),
});
